import {
	EmptySVG,
	LineOfCreditIcon,
	LoanIcon,
	SecuredLoanIcon,
	StudentLoanRefinanceIcon
} from 'components/domain/search/offers/common/icons/icons'

export const LoanAdvertisingCopy: LoanAdvertising = {
	LowestAPR: '5.99%'
}

interface LoanAdvertising {
	LowestAPR: string
}

export enum CategoryIcons {
	Secured = 'secured-loan',
	Loan = 'loan',
	SLR = 'slr',
	LOC = 'loc'
}

const ReshapedCategoryIconMap: Record<CategoryIcons, () => JSX.Element> = {
	[CategoryIcons.Secured]: SecuredLoanIcon,
	[CategoryIcons.Loan]: LoanIcon,
	[CategoryIcons.SLR]: StudentLoanRefinanceIcon,
	[CategoryIcons.LOC]: LineOfCreditIcon
}

export const getReshapedCategoryIcon = (icon: CategoryIcons) => {
	return ReshapedCategoryIconMap[icon] || EmptySVG
}
